import * as React from 'react';
import { useMemo, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import ResultsChart from './ResultsChart';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import ImageWithResults from '../common/ImageWithResults';
import {
  POLL_AND_QUIZ_SUBTYPE,
  QUESTION_STATE_SCENARIOS,
  QUESTION_TYPE_OPTIONS_MAP,
  QUESTION_TYPES,
  RESULTS_VISIBILITY
} from '../../constants/appConstants';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import OptionsDnD from './OptionsDnD';
import paella from '../../static/images/paella.jpg';
import { addDays, formatRelative } from 'date-fns';
import BasicRating from './BasicRating';
import CommonPuzzleCurrent from '../../views/questionTypeExamples/CommonPuzzleCurrent';
import { SubmitQuestionContainer } from './SubmitQuestionContainer';
import MinAndMaxSlider from './MinAndMaxSlider';
import { getRankUpOrDown } from '../../utils/helper';
import CrosswordPuzzle from '../../views/questionTypeExamples/CrosswordPuzzle';
import StartGameWrapper from '../common/StartGameWrapper';
import WordlePuzzle from "../../views/questionTypeExamples/wordle";
import { QuestionState } from './QuestionState';
import { useQuestionStore } from '../../store/useQuestionStore';
import PartiallyCompletedModal from './PartiallyCompletedModal';
import MinAndMaxResults from './MinAndMaxResults';
import CrossMathPuzzle from '../../views/crossMath/answers';

export default function QuestionOptions({ showOnlyResults, options = [], questionType, subType, settings, questionIndex }) {

  const [defaultValue, setDefaultValue] = useState('')
  const [isVoteSubmitted, setIsVoteSubmitted] = useState(showOnlyResults)
  const [solvingMethod, setSolvingMethod] = useState('')
  const [isEnteringManualOption, setIsEnteringManualOption] = useState(false)
  const [manualEnteredOption, setManualEnteredOption] = useState('')
  const [showOptions, setShowOptions] = useState(settings.showOptionsOnLoad)
  const questionStore = useQuestionStore()
  const currentState = questionStore.questionState[questionIndex];
  const { PARTIALLY_SOLVED: PARTIALLY_VALID, NOT_STARTED } = QUESTION_STATE_SCENARIOS
  const modalScenarios = [PARTIALLY_VALID, NOT_STARTED]

  console.log("QuestionOptions questionType1", questionType);



  const {BASIC_MATH, CONNECTIONS, CROSS_WORD_PUZZLE, DOUBLE_PUZZLE, FACT, FLASH_CARD, GUESS_BLURRED_IMAGE, IMAGE_SWAP, 
    IMAGE_WORD_PUZZLE, JIGSAW_PUZZLE, JUMBLED_SENTENCE, MARKS, MATH_SQUARE, MEMORY_GAME, POLL, QUIZ, RANK, 
    RATING, SPIN_A_WHEEL, SPIN_THE_WHEEL, WORDLE, WORD_SEARCH_PUZZLE
  } = QUESTION_TYPES

  const handleSubmitVote = () => {
    questionStore.updateSubmitState(questionIndex, true)
    setIsVoteSubmitted(!isVoteSubmitted)
    // if (currentState) {
    //   if (!modalScenarios.includes(currentState.answerState)) {
    //     console.log("Opening Puzzle", !isVoteSubmitted);
    //     setIsVoteSubmitted(!isVoteSubmitted)
    //   }
    // }

  }

  const handleSingleSelectionChange = (value) => {
    setDefaultValue(value)
  }

  const renderSingleSelectText = () => {
    return <RadioGroup
      aria-labelledby="single-select-text-radio-buttons-group-label"
      defaultValue={defaultValue}
      onChange={(event, value) => handleSingleSelectionChange(value)}
      name="radio-buttons-group"
    >
      {options.map(option => {
        return <FormControlLabel value={option} control={<Radio />} label={option} />
      })}
      <FormControlLabel value={''} control={<Radio
        onClick={() => {
          setIsEnteringManualOption(true)
        }}
        onBlur={() => {
          setIsEnteringManualOption(false)
        }}
        checked={isEnteringManualOption} />}
        label={
          <TextField id="others-input" label="Others" variant="outlined"
            value={manualEnteredOption}
            onChange={(ev) => {
              setManualEnteredOption(ev.target.value)
            }}
            onFocus={() => {
              setIsEnteringManualOption(true)
            }}
          />
        } />
    </RadioGroup>
  }

  const renderMultiSelect = () => {
    return <>
      <FormGroup>
        {options.map(option => {
          return <FormControlLabel control={<Checkbox />} label={option} />
        })}
      </FormGroup>
    </>
  }

  const optionImageUrls = () => options.map(option => {
    return paella
  })

  const optionImageUrlsTemp = useMemo(() => optionImageUrls(), [])
  const renderSingleSelectImage = () => {
    return <>
      <Grid container spacing={2}>
        {options.map((option, index) => {
          return <Grid item xs={6}>
            <Card sx={{ border: `${defaultValue === option ? '3px solid blue' : '2px groove'}` }}>
              <CardMedia
                component="img"
                alt={option}
                height="140"
                image={optionImageUrlsTemp[index]}
              />
              <CardActions>
                <Radio
                  checked={defaultValue === option}
                  onChange={() => handleSingleSelectionChange(option)}
                  value={option}
                  name={`radio-buttons-${option}`}
                  inputProps={{ 'aria-label': option }}
                />
                <Typography>
                  {option}
                </Typography>
              </CardActions>
            </Card>
          </Grid>
        })}
      </Grid>
    </>
  }

  const renderRankOptions = () => {
    return <><OptionsDnD options={options} /></>
  }


  const renderOptionsSelect = () => {
    console.log("renderOptionsSelect1", questionType)
    if (questionType === RATING) {
      return <BasicRating />
    } else if (questionType === RANK) {
      return renderRankOptions()
    } else if (subType === POLL_AND_QUIZ_SUBTYPE.TEXT) {
      return renderSingleSelectText()
    } else if (subType === POLL_AND_QUIZ_SUBTYPE.IMAGE) {
      return renderSingleSelectImage()
    } else if (subType === POLL_AND_QUIZ_SUBTYPE.MULTI_CHOICE_TEXT) {
      return renderMultiSelect()
    } else if (questionType === CROSS_WORD_PUZZLE) {
      return <StartGameWrapper questionType={questionType}><CrosswordPuzzle /></StartGameWrapper>
    } else if (questionType === WORDLE) {
      return <StartGameWrapper questionType={questionType}><WordlePuzzle /></StartGameWrapper>
    } else if ([JIGSAW_PUZZLE, SPIN_A_WHEEL, IMAGE_SWAP, MATH_SQUARE, IMAGE_WORD_PUZZLE].includes(questionType)) {
      return <CommonPuzzleCurrent settings={settings} questionType={questionType} />
    } else if (questionType === MARKS) {
      return <>
        <MinAndMaxSlider />
      </>
    }

    return <>Invalid Question type</>
  }

  const renderOptionResult = () => {
    if ((questionType === RANK)
      || (subType === POLL_AND_QUIZ_SUBTYPE.TEXT)
      || (subType === POLL_AND_QUIZ_SUBTYPE.MULTI_CHOICE_TEXT)) {
      if (settings.resultsVisibility === RESULTS_VISIBILITY.NOT_PUBLIC) {
        return <>Only Author can see your votes</>
      }
      if (settings.resultsVisibility === RESULTS_VISIBILITY.PUBLIC_AFTER_END_DATE) {
        return <>Results are visible only after poll ends
          {formatRelative(new Date(), addDays(new Date(), 10))}
          Save your poll to view results later.</>
      }
      if (manualEnteredOption !== '') {
        return <ResultsChart showOnlyResults={showOnlyResults} questionType={questionType}
          options={[...options, ...[manualEnteredOption]]} />
      }
      return <ResultsChart showOnlyResults={showOnlyResults} options={options} questionType={questionType} />
    } else if (subType === POLL_AND_QUIZ_SUBTYPE.IMAGE) {
      return <ImageWithResults options={options} />
    } else if (subType === POLL_AND_QUIZ_SUBTYPE.RATING) {
      return <BasicRating showResults={true} />
    } else if (questionType === WORDLE) {
      return <>
        <StartGameWrapper questionType={questionType}><WordlePuzzle isVoteSubmitted={isVoteSubmitted} /></StartGameWrapper>
        <ResultsChart options={QUESTION_TYPE_OPTIONS_MAP[questionType]} questionType={questionType} />
      </>
    }  else if ([JIGSAW_PUZZLE, CROSS_WORD_PUZZLE,
    SPIN_A_WHEEL, IMAGE_SWAP, MATH_SQUARE, IMAGE_WORD_PUZZLE].includes(questionType)) {
      return <>
        <CommonPuzzleCurrent settings={settings} questionType={questionType} isVoteSubmitted={isVoteSubmitted}
          solvingMethod={solvingMethod} />
        <ResultsChart options={QUESTION_TYPE_OPTIONS_MAP[questionType]} questionType={questionType} />
      </>
    } else if (questionType === MARKS) {
      return <>
        <MinAndMaxResults />
      </>
    }


    return <>Invalid Question type results</>
  }

  
  if (!showOptions) {
    return <Button variant="contained" onClick={() => setShowOptions(true)}>Show options</Button>
  }

  console.log("isVoteSubmitted2", isVoteSubmitted, settings.isStartButtonRequired);
  return (
    <Box sx={{ ml: 2 }}>
      <FormControl fullWidth={true}>
        <QuestionState questionIndex={questionIndex} />
        {isVoteSubmitted ? <>{renderOptionResult()}</> : <>{renderOptionsSelect()}</>}


        <SubmitQuestionContainer options={options}
          questionType={questionType}
          settings={settings}
          handleSubmitVote={handleSubmitVote}
          isVoteSubmitted={isVoteSubmitted}
          solvingMethod={solvingMethod}
          setSolvingMethod={(method) => setSolvingMethod(method)}
          questionIndex={questionIndex} />
      </FormControl>
    </Box>
  );
}
